import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  max-inline-size: ${spacing(60.75)}; // 486px
`
export const phoneInput = css`
  margin-block-end: ${spacing(2)};
  font-family: ${cssTheme.fontFamily.ysText};
`
